import React, { Fragment } from 'react';
export function PainPointsSection() {
  const painPoints = ['"Stolen" Sunday evenings spent desperately searching for a lesson plan that actually works for your group.', 'Fragmented sessions because you lack a unified, professional curriculum for the whole year.', 'On-the-spot panic when the gym is unavailable, a class runs long, or 5 extra students show up unannounced.', 'Creative exhaustion from trying to reinvent the wheel for every single unit, sport, and skill level.', 'Students asking "What are we doing today?" because your lessons feel repetitive, unstructured, or unplanned.', 'Walking into class still improvising, changing activities on the fly, and hoping something works.'];
  return <section className="bg-brand-dark py-16 md:py-24 px-4 border-t border-brand-border" data-id="element-165">
      <div className="max-w-3xl mx-auto" data-id="element-166">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold text-brand-ink text-center mb-10 md:mb-14 leading-snug px-2" data-id="element-167">
          If you teach PE in a school,
          <br data-id="element-168" />
          <span className="text-brand-accent" data-id="element-169">
            you know this feeling all too well:
          </span>
        </h2>
        <div className="space-y-4 md:space-y-5 mb-14 md:mb-16" data-id="element-170">
          {painPoints.map((point, index) => <div key={index} className="flex items-center gap-4 md:gap-5 py-5 md:py-6 px-5 md:px-7 rounded-2xl bg-brand-card border border-brand-border" data-id="element-171">
              <div className="flex-shrink-0 w-8 h-8 md:w-10 md:h-10 bg-brand-red/10 rounded-lg flex items-center justify-center text-brand-red font-black text-lg md:text-xl" data-id="element-172">
                ✕
              </div>
              <p className="text-base sm:text-lg md:text-xl text-brand-ink font-semibold leading-snug" data-id="element-173">
                {point}
              </p>
            </div>)}
        </div>
        <div className="text-center px-4" data-id="element-174">
          <p className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold leading-tight italic text-brand-red" data-id="element-175">
            How many hours of your life have you already lost "building" lessons
            from scratch every single week?
          </p>
        </div>
      </div>
    </section>;
}